import React from "react";
import { RefinementList, Index, InfiniteHits } from "react-instantsearch";

import EmptyQueryBoundary from "./EmptyQueryBoundary";
import NoResultsBoundary from "./NoResultsBoundary";
import Hit from "./Hit";
import CustomStats from "./CustomStats";
import NoResults from "./NoResults";

const translations = {
  en: {
    showMore: "Show more results",
    labels: {
      Posts: "News",
      Page: "Page",
      Resource: "Resource",
    },
  },
  fr: {
    showMore: "Afficher plus de résultats",
    labels: {
      Posts: "Nouvelles",
      Page: "Page",
      Resource: "Ressource",
    },
  },
};

const lang = document.documentElement.lang || "en";
const t = translations[lang] || translations.en;

const transformItems = (items /*, { results }*/) => {
  return items.map((item, index) => ({
    ...item,
    position: index,
  }));
};

const transformRefinementLabels = (items) => {
  return items.map((item) => ({
    ...item,
    label: t.labels[item.label] || item.label,
  }));
};

export default function Results({ setNumHits }) {
  return (
    <EmptyQueryBoundary fallback={null}>
      <div className="search-results">
        <Index indexName="wp_searchable_posts">
          <CustomStats setStats={setNumHits} />
          <div className="search-results-panel">
            <RefinementList
              attribute="post_type_label"
              classNames={{ checkbox: "visually-hidden" }}
              transformItems={transformRefinementLabels}
            />
            <NoResultsBoundary fallback={<NoResults />}>
              <InfiniteHits
                showPrevious={false}
                classNames={{ loadMore: "cta", disabledLoadMore: "hidden" }}
                hitComponent={({ hit }) => <Hit hit={hit} />}
                transformItems={transformItems}
                translations={{
                  showMoreButtonText: t.showMore,
                }}
              />
            </NoResultsBoundary>
          </div>
        </Index>
      </div>
    </EmptyQueryBoundary>
  );
}
